import type { RouteRecordRaw } from 'vue-router'
import { Layout, getParentLayout } from '@/utils/routerHelper'

const contentRoutes: RouteRecordRaw[] = [
  {
    path: '/content',
    component: Layout,
    name: 'Content',
    meta: {
      title: '内容中心',
      icon: 'vi-ant-design:file-text-outlined',
      alwaysShow: true
    },
    children: [
      {
        path: 'banner',
        name: 'ContentBannerList',
        component: () => import('@/views/Admin/Content/Banner/List.vue'),
        meta: { title: 'banner管理', icon: 'mdi-image-multiple-outline' }
      },
      {
        path: 'agreement',
        name: 'SystemAgreement',
        component: () => import('@/views/System/Agreement/List.vue'),
        meta: { title: '协议规则管理', icon: 'mdi-file-document-outline' }
      },
      {
        path: 'news',
        name: 'ContentNews',
        component: getParentLayout(),
        meta: { title: '新闻管理', icon: 'mdi-newspaper-variant-outline', alwaysShow: true },
        children: [
          {
            path: 'types',
            component: () => import('@/views/Admin/Content/News/Types.vue'),
            name: 'ContentNewsTypes',
            meta: { title: '新闻分类' }
          },
          {
            path: 'list',
            component: () => import('@/views/Admin/Content/News/List.vue'),
            name: 'ContentNewsList',
            meta: { title: '新闻列表' }
          }
        ]
      },
      {
        path: 'help',
        name: 'ContentHelp',
        component: getParentLayout(),
        meta: { title: '帮助中心', icon: 'mdi-help-circle-outline', alwaysShow: true },
        children: [
          {
            path: 'types',
            component: () => import('@/views/Admin/Content/Help/Types.vue'),
            name: 'ContentHelpTypes',
            meta: { title: '帮助分类' }
          },
          {
            path: 'list',
            component: () => import('@/views/Admin/Content/Help/List.vue'),
            name: 'ContentHelpList',
            meta: { title: '帮助列表' }
          }
        ]
      },
      /*{
        path: 'partner',
        name: 'ContentPartner',
        component: () => import('@/views/Admin/Content/Partner/List.vue'),
        meta: { title: '合作商家', icon: 'mdi-store-outline' }
      },*/
      {
        path: 'brand',
        name: 'ContentBrand',
        component: () => import('@/views/Admin/Content/Brand/List.vue'),
        meta: { title: '品牌介绍', icon: 'mdi-trademark' }
      },
      {
        path: 'area',
        name: 'ContentArea',
        component: () => import('@/views/Admin/Content/Area/List.vue'),
        meta: { title: '地区管理', icon: 'mdi-map-marker-radius-outline' }
      },
      {
        path: 'sensitive-word',
        name: 'ContentSensitiveWord',
        component: () => import('@/views/System/Setting/SensitiveWord.vue'),
        meta: { title: '敏感词库', icon: 'mdi-shield-alert-outline' }
      },
      // 以下为图中未列出的历史菜单，隐藏保留路由
      {
        path: 'display/marquee',
        name: 'ContentMarqueeList',
        component: () => import('@/views/Admin/Content/Marquee/List.vue'),
        meta: { title: '平台动态', hidden: true }
      },
      {
        path: 'display/about',
        name: 'ContentAbout',
        component: () => import('@/views/Admin/Content/About/List.vue'),
        meta: { title: '关于我们', hidden: true }
      },
      {
        path: 'engage/appointment',
        name: 'ContentAppointment',
        component: () => import('@/views/Admin/Content/Appointment/List.vue'),
        meta: { title: '在线预约', hidden: true }
      },
      {
        path: 'engage/circle/category',
        name: 'ContentCircleCategory',
        component: () => import('@/views/Admin/Content/Circle/Category.vue'),
        meta: { title: '官方动态分类', hidden: true }
      },
      {
        path: 'engage/circle/post',
        name: 'ContentCirclePost',
        component: () => import('@/views/Admin/Content/Circle/Post.vue'),
        meta: { title: '官方动态', hidden: true }
      },
      {
        path: 'library/reward',
        name: 'ContentReward',
        component: () => import('@/views/Admin/Content/Reward/List.vue'),
        meta: { title: '权益中心', hidden: true }
      },
      {
        path: 'share',
        name: 'ContentShare',
        component: () => import('@/views/Admin/Content/Share/List.vue'),
        meta: { title: '分享管理' }
      }
    ]
  }
]

export default contentRoutes
